import React from 'react';

import {
  Balance,
  BalanceImage,
  BalanceInfo,
  Container,
  Content,
  ContentTitles,
  IndicationActions,
  IndicationColumn,
  IndicationFooter,
  IndicationInfos,
  IndicationItem,
  IndicationName,
  SwitchButton,
  SwitchContainer,
} from './styles';
import {Header} from '../../../../components/Interface/Headers/Header';
import {useNavigation, useRoute} from '@react-navigation/native';
import {Titles} from '../../../../components/Interface/Typographies/Titles';
import {api} from '../../../../services/api';
import {FlatList} from 'react-native-gesture-handler';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';

import {NotFound} from '../../../../components/Interface/Search/NotFound';
import {Alert} from 'react-native';
import {Icon} from '../../../../components/Interface/Typographies/Icon';

interface ReferAndWinUsers {
  qtde_indicados: number;
  lista_indicados: any[];
}

interface Params {
  data: ReferAndWinUsers;
}

export function ReferAndWinUsersDesactivated() {
  const navigation = useNavigation();
  const route = useRoute();

  const {data} = route.params as Params;

  function formataNome(nome: string) {
    var partesDoNome = nome.split(' ');
    var primeiroNome = partesDoNome[0];

    if (partesDoNome.length >= 2) {
      var ultimoNome = partesDoNome[1];

      return primeiroNome + ' ' + ultimoNome;
    } else {
      return nome;
    }
  }

  function toggleSwitch(status: string, id: string) {
    if (status === 'inativo') {
      reativarIndicado(id);
    }
  }

  async function reativarIndicado(id: string) {
    try {
      await api
        .post('/reativarIndicado', {
          indicado_id: id,
        })
        .then(() => {
          navigation.goBack();
        });
    } catch ({response}: any) {
      if (response.data) {
        Alert.alert('Ocorreu um problema', response.data.msg, [
          {
            text: 'Ok',
            isPreferred: true,
          },
        ]);
      } else {
        Alert.alert(
          'Ocorreu um problema',
          'Não foi possível ativar o indicado.',
          [
            {
              text: 'Ok',
              isPreferred: true,
            },
          ],
        );
      }
    }
  }

  return (
    <Container>
      <Header icon="chevron-left" />
      <Content>
        <ContentTitles>
          <Titles
            title="Usuários inativos"
            subtitle="Aqui está uma lista com todos os usuários que você indicou, mas que estão inativos."
          />
        </ContentTitles>
        {data.lista_indicados &&
        data.lista_indicados.filter(item => item[5] === 'inativo').length >
          0 ? (
          <FlatList
            data={data.lista_indicados.filter(item => item[5] === 'inativo')}
            contentContainerStyle={{paddingBottom: RFValue(20)}}
            keyExtractor={item => item}
            renderItem={({item}) => (
              <IndicationItem>
                <IndicationColumn>
                  <Icon name="user" />
                  <IndicationInfos>
                    <IndicationName>{formataNome(item[0])}</IndicationName>
                    <IndicationFooter>
                      <BalanceInfo>
                        <BalanceImage
                          source={require('../../../../assets/images/icons/baratinha.webp')}
                        />
                        <Balance>{item[2]} btz</Balance>
                      </BalanceInfo>
                    </IndicationFooter>
                  </IndicationInfos>
                </IndicationColumn>

                <IndicationActions>
                  <SwitchContainer>
                    <SwitchButton
                      value={item[5] !== 'inativo'}
                      onValueChange={() => toggleSwitch(item[5], item[4].$oid)}
                    />
                  </SwitchContainer>
                </IndicationActions>
              </IndicationItem>
            )}
          />
        ) : (
          <NotFound
            style={{marginTop: -RFPercentage(8)}}
            title="Nada por aqui..."
            text="Você não possui usuários indicados inativos."
          />
        )}
      </Content>
    </Container>
  );
}
